import * as React from 'react';
import { Box } from '@material-ui/core';
import { useStyles } from './MainContentWrapper.styles';
import { MainLogo } from '../../pages/Main/components/MainLogo';
import { Footer } from '../../pages/Main/components/Footer';

type MainContentWrapperProps = React.PropsWithChildren<{}>;

const MainContentWrapper: React.FC<MainContentWrapperProps> = ({children}) => {
  const styles = useStyles();

  return (
    <Box className={styles.root}>
      <MainLogo/>
      <Box className={styles.content}>{children}</Box>
      <Footer/>
    </Box>
  )
}

export default MainContentWrapper;